
(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('selectizeObjectSelector', selectizeObjectSelector);

    function selectizeObjectSelector(lodash) {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                config: '=',
                options: '=?',
            },
            controller: selectizeObjectSelectorCtrl,
            templateUrl: 'common/components/selectize-object',
            link: function (scope, elem, attrs, ngModelCtrl) {
                const valueKey = lodash.get(scope.myConfig, 'valueField', 'id');

                ngModelCtrl.$formatters.push(function (modelValue) {
                    return lodash.get(modelValue, valueKey, modelValue);
                });

                ngModelCtrl.$render = function() {
                    scope.myModel = ngModelCtrl.$viewValue;
                };

                ngModelCtrl.$parsers.push(function(viewValue) {
                    const value = lodash.find(scope.options, { [valueKey]: viewValue });
                    return value || viewValue;
                });

                scope.onModelChange = function () {
                    ngModelCtrl.$setViewValue(scope.myModel);
                    if (lodash.has(scope.config, 'events.change')) {
                        var option = lodash.find(scope.options, function(option) {
                            return option[valueKey] == scope.myModel;
                        }); // { [valueKey]: scope.myModel });
                        scope.$emit(scope.config.events.change, {
                            model: scope.myModel,
                            label: option.label
                        });
                    }
                };

            },
            // template: '<selectize options="options" config="config" ng-model="myModel" ng-change="onModelChange()"></selectize>'

        };
    }

    function selectizeObjectSelectorCtrl($scope, lodash, GenericModel) {
        this.$onInit = function() {
            if ($scope.options === undefined) {
                $scope.options = [];
            }
            $scope.myConfig = angular.merge(
                {
                    highlight: true,
                    create: false,
                    labelField: 'label',
                    valueField: 'value',
                    maxItems: 1,
                    searchField: ['label'],
                    plugins: ['remove_button'],
                    onInitialize: function(selectize) {
                        $scope.selectizeObject = selectize;
                        loadRemoteData();
                    }
                },
                $scope.config
            );
        }

        function loadRemoteData() {
            if (lodash.has($scope.config, 'datasource.url')) {
                $scope.isLoading = true;
                var callRemoteApiPromise = callRemoteApi();
                callRemoteApiPromise.then(function(res) {
                    $scope.isLoading = false;
                    $scope.options = res;
                });
            }
        }

        function callRemoteApi() {
            var model = new GenericModel($scope.config.datasource.url);
            var method = lodash.get($scope.config.datasource, 'method', 'get');
            return model[method]({}).$promise.then(function(res) { //res
                if (res.success && res.status_code == 200) {
                    return res.data;
                } else {
                    return null;
                }
            }, function(res) {
                console.warn(res); // eslint-disable-line no-console
                return null;
            });
        }
    }
})();